<h2 mat-dialog-title>Detalle del Pedido</h2>
<mat-dialog-content>
  <div *ngIf="data.order">
    <table class="order-details-table">
      <!-- <tr>
        <td><b>ID:</b></td>
        <td>{{ data.order.id }}</td>
      </tr> -->
      <tr>
        <td><b>Fecha de creación:</b></td>
        <td>{{ formatDate(data.order.createdAt) }}</td>
      </tr>
      <tr>
        <td><b>Cliente:</b></td>
        <td>{{ data.order.recipientName }}</td>
      </tr>
      <tr>
        <td><b>Teléfono de retiro:</b></td>
        <td>{{ data.order.pickupPhone }}</td>
      </tr>
      <tr>
        <td><b>Teléfono de entrega:</b></td>
        <td>{{ data.order.deliveryPhone }}</td>
      </tr>
      <tr>
        <td><b>Horario de retiro:</b></td>
        <td>{{ formatTimeRange(data.order.pickupTimeRange) }}</td>
      </tr>
      <tr>
        <td><b>Horario de entrega:</b></td>
        <td>{{ formatTimeRange(data.order.deliveryTimeRange) }}</td>
      </tr>
      <tr class="address-row">
        <td class="address-label"><b>Origen:</b></td>
        <td class="address-value-cell">
          <div class="address-value-content">
            <span>{{ getOriginAddress() }}</span>
            <span *ngIf="getOriginAddressDetail()"> - {{ getOriginAddressDetail() }}</span>
          </div>
        </td>
      </tr>
      <tr class="address-row">
        <td class="address-label"><b>Destino:</b></td>
        <td class="address-value-cell">
          <div class="address-value-content">
            <span>{{ getDestinationAddress() }}</span>
            <span *ngIf="getDestinationAddressDetail()"> - {{ getDestinationAddressDetail() }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td><b>Distancia:</b></td>
        <td>
          {{
            data.order.distanceKm
              ? (data.order.distanceKm | number : "1.2-2") + " km"
              : "-"
          }}
        </td>
      </tr>
      <tr>
        <td><b>Costo calculado:</b></td>
        <td>
          {{
            data.order.calculatedCost
              ? (data.order.calculatedCost | currency : "ARS")
              : "-"
          }}
        </td>
      </tr>
      <tr>
        <td><b>Costo final:</b></td>
        <td>
          {{
            data.order.finalCost !== null && data.order.finalCost !== undefined
              ? (data.order.finalCost | currency : "ARS")
              : "-"
          }}
        </td>
      </tr>
      <tr>
        <td><b>Costo final con IVA:</b></td>
        <td>
          {{
            data.order.finalCostWithIVA !== null && data.order.finalCostWithIVA !== undefined
              ? (data.order.finalCostWithIVA | currency : "ARS")
              : "-"
          }}
        </td>
      </tr>
      <tr>
        <td><b>Cadete:</b></td>
        <td>{{ data.order.assignedDeliveryName ? ( data.order.assignedDeliveryName + "("+ data.order.assignedDeliveryPhone +")") : "-"}}</td> 
      </tr>
      <tr>
        <td><b>Estado:</b></td>
        <td>{{ getStatusLabel(data.order.status || 0) }}</td>
      </tr>
      <tr>
        <td><b>Forma de pago:</b></td>
        <td>{{ getWhereToPayLabel(data.order.whereToPay || 0) }}</td>
      </tr>
      <tr>
        <td><b>Observaciones:</b></td>
        <td>{{ data.order.observations || '-' }}</td>
      </tr>
      <tr *ngIf="data.order.scheduledAt">
        <td><b>Fecha programada:</b></td>
        <td>{{ formatDateOnly(data.order.scheduledAt) }}</td>
      </tr>
      <!-- Waypoints Section -->
      <tr *ngIf="sortedWaypoints.length">
        <td><b>Paradas:</b></td>
        <td>
          <div class="waypoints-container">
            <div class="waypoint" *ngFor="let waypoint of sortedWaypoints; let i = index"
     [ngClass]="'waypoint-status-' + waypoint.status">
  <div class="waypoint-header">
    <span class="waypoint-number"
          [ngClass]="'waypoint-status-' + waypoint.status">
      Parada {{ getWaypointDisplayNumber(waypoint, i) }} - {{ getWaypointStatusLabel(waypoint.status) }}
    </span>
  </div>
  <div class="waypoint-address">
    <mat-icon class="waypoint-icon">location_on</mat-icon>
    {{ waypoint.address }}
  </div>
  <div class="waypoint-detail" *ngIf="waypoint.addressDetail">
    <mat-icon class="waypoint-icon" style="font-size: 18px; width: 18px; height: 18px;">info</mat-icon>
    {{ waypoint.addressDetail }}
  </div>
  <div class="waypoint-time" *ngIf="getWaypointTime(waypoint.id) !== null">
    Tiempo en parada: <br>
    {{ getWaypointTime(waypoint.id) }} min
  </div>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="close()">Cerrar</button>
</mat-dialog-actions>
